import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { faMapPin } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';

export const Location = ({
  location,
  className,
  loading,
}: {
  location: string;
  className?: string;
  loading?: boolean;
}) => {
  if (!location && !loading) return null;
  return (
    <div className={clsx('flex items-center gap-1.5 capitalize', className)}>
      <FontAwesomeIcon icon={faMapPin} />
      {loading ? (
        <div className="h-[18px] w-[88px] animate-pulse rounded-md bg-neutral200" />
      ) : (
        <p>{location}</p>
      )}
    </div>
  );
};
